module.exports = __webpack_public_path__ + "img/SKMA_car.08f69948.png";